import { SET_SYSTEM_MESSAGE } from 'store/key';
import { produce } from 'utility/general';

const initialState = {
    systemMessage: {
        uploadError_001: 'File size must be equal to or less than r%0.',
        passCode_002:
            'Min length 8, contains at least one numeric character, one upper case and one lower case character.',
        passCode_003: 'Confirm password is not matched.',
        required: 'This field is required.',
        invalidEmail_001: 'Invalid email address format.',
        authorizedSignUpSuccess:
            'Account is registered successfully and please check your mail box for activation email.',
        nonAuthorizedSignUpSuccess: 'Sign up request was submitted for approval.',
        chineseNotAllowedInput: 'Chinese characters are not allowed in this field.',
        sendEmail_001: 'Email sent. Please check your email.',
        sendEmail_activation: 'Activation email sent. Please check your email.',
        accountActivated: 'Account activated, you may now login to the system.',
        resetPassCodeSuccess: 'Reset password successfully. You may now login to the system.',
        invalidEmailDomain: 'Invalid email domain format.',
        approvePendingApprovalUserSuccess: 'This user has been approved.',
        rejectPendingApprovalUserSuccess: 'This user has been rejected.',
        selectedAtLeastOne: 'At least one of the user groups should be selected.',
        lessLength: 'This field cannot be less than r%0 character.',
        longerLength: 'This field cannot be longer than r%0 characters.',
        uploadError_002: 'Executable file denied.',
        gotChannel: 'Channel r%0 was chosen',
        checkCompleteness: '*Please check the r%0 for completeness',
        uploadError_003: 'File size must be greater than 0MB.',
        updateCodeSuccess: 'Updated Successfully.',
        inquirySendActivation: 'Are you sure to resend the activation link?',
        updateSuccess: 'Update successfully.',
        warnChoseDecision: 'You need to choose decision first.',
        warnChoseDecisionAndRefNo: 'Please select "Decision" and input "IRB/REC Reference No.',
        warnChosenDateOrFile: `Please click "Cancel" if you do not want to update "Approval Expiry Date" or upload "Approval Letter".`,
        updatedAccount: 'User account has been updated.',
        ctcCtiRequired: `Please upload attachment.`,
        sendToReviewer: 'Send to reviewer directly after submission?',
        isSureToChange: `Are you sure to change the r%0?`,
        disableEnableAcc: `Are you sure to r%0 this account?`,
        emailSent: 'The email has been sent to your mailbox, please check.',
        hasBeenUpdated: 'r%0 has been updated.',
    },
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_SYSTEM_MESSAGE:
            const newState = produce(state, (draft) => {
                Object.entries(action.payload).forEach(([key, value]) => {
                    draft[key] = action.payload[key];
                });
            });
            return newState;
        default:
            return state;
    }
};
export function getSystemMessage(errorCode = null, replaceStr = []) {
    let message = '';
    if (errorCode) {
        message = initialState.systemMessage[errorCode];
        if (replaceStr.length) {
            for (const [idx, val] of replaceStr.entries()) {
                message = message.replace('r%' + idx, val);
            }
        }
    }
    return message;
}
export default reducer;
